import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import CampaignPage from './components/CampaignPage';
import ReportPage from './components/ReportPage';
import CheckinPage from './components/CheckinPage';
import CheckinReportPage from './components/CheckinReportPage';
import './App.css';


// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    // Show loading while checking authentication
    if (isLoading) {
        return <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontSize: '18px',
            color: '#4A90E2'
        }}>Loading...</div>;
    }

    // Pass the intended destination in location state so Login can redirect back
    return isAuthenticated ? children : <Navigate to="/login" state={{ from: location }} replace />;
};

function AppRoutes() {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <CampaignPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/report"
                element={
                    <ProtectedRoute>
                        <ReportPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin-report"
                element={
                    <ProtectedRoute>
                        <ReportPage orgWide />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/checkin"
                element={
                    <ProtectedRoute>
                        <CheckinPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/checkin-report"
                element={
                    <ProtectedRoute>
                        <CheckinReportPage />
                    </ProtectedRoute>
                }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <AppRoutes />
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
